import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ISharePointFileLintCardItem } from 'src/app/components/main-content/design-lookup/share-point-file-link-card/share-point-file-link-card.component';
import { ElementHistoryDocument } from 'src/app/models/domain';
import { DesignService, SiriusElementHistoryDocumentService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-sirius-element-history-document-link',
  templateUrl: './sirius-element-history-document-link.component.html',
  standalone: false,
})
export class SiriusElementHistoryDocumentLinkComponent implements OnInit, OnDestroy {
  public siriusElementHistoryDocuments$ =
    this.siriusElementHistoryDocumentService.siriusElementHistoryDocuments$.pipe(
      map((siriusElementHistoryDocument) =>
        this.mapToSharePointLinkCardItem(siriusElementHistoryDocument)
      )
    );

  public siriusElementHistoryDocumentsLoading$ = this.siriusElementHistoryDocumentService.loading$;

  public error$ = this.siriusElementHistoryDocumentService.error$;
  public siteUrl = environment.sharePointSiriusEHDSiteUrl;
  public readonly trackByRef = trackByRef;

  public isDesignLoading = false;

  private readonly designLoading$ = this.designService.loading$;
  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly siriusElementHistoryDocumentService: SiriusElementHistoryDocumentService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(
          switchMap((designId) =>
            this.siriusElementHistoryDocumentService.loadSiriusElementHistoryDocumentsByDesignId(
              designId
            )
          )
        )
        .subscribe()
    );

    this.subscriptions.add(
      this.designLoading$.subscribe((designLoading) => (this.isDesignLoading = designLoading))
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private mapToSharePointLinkCardItem(
    documents: ElementHistoryDocument[]
  ): ISharePointFileLintCardItem[] {
    return documents.map((document) => ({
      name: document.name,
      sharePointSiteUrl: this.siteUrl,
      webUrl: document.webUrl,
    }));
  }
}
